import gql from 'graphql-tag';


export const queryAllContentUnderstandingQuestions = gql`query ent($aIQuestionType: String)  {
                getAIQuestions (aIQuestionType: $aIQuestionType) {
                        id
                        masterItemId
                        name
                        description
                        question
                        tenantId
                        matchAbsence
                        aiQuestionGroup{
                            id
                            name
                            generalGroup
                        }
                        aIQuestionType
                        active
                        logInteraction
                        automated
                        saveResult
                        mergeResults
                    }
         }`

export const queryGetContentUnderstandingQuestion = gql`query ent ($id: String) {
                getAIQuestion (id: $id) {
                        id
                        name
                        description
                        question
                        tenantId
                        version
                        masterItemId
                        selected
                        matchAbsence
                        aiQuestionGroup{
                            id
                            generalGroup
                        }
                        aIQuestionType
                        active
                        logInteraction
                        automated
                        saveResult
                        customField
				    mergeResults 
                    }
         }`